<template>
  <w-popup-show :state="state">
    <div slot="content" class="jobs-mailing-container">
      <div class="mailing-content">
        <div class="icon-container flex-end">
          <span class="iconfont iconx"></span>
        </div>
        <div class="flex-column-center">
          <div class="title">
            <img src="" alt="">
          </div>
        </div>
      </div>
    </div>
  </w-popup-show>
</template>

<script>
	import WPopupShow from '../../components/global/w-popup-show'

	export default {
		name: 'more-jobs-mailing',
		props: {
			state: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WPopupShow
		},
		methods: {}
	}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";
  @import "@/assets/scss/global/mixin";
  .jobs-mailing-container {
    width: 100vw;
    padding: 24px;
    border-radius: 16px 16px 0 0;
    background-color: $color-light;
    .icon-container {
      .iconfont {
        color: $color-title;
        font-weight: bold;
      }
    }
  }
</style>
